import { axios } from '@ben/api/axios';
import { z } from 'zod';

const benefitTypes = z.array(z.string());

type BenefitTypes = z.infer<typeof benefitTypes>;

export const getBenefitTypes = async (): Promise<BenefitTypes> => {
  const response = await axios.get<BenefitTypes>('benefit-type/');
  try {
    return benefitTypes.parse(response?.data);
  } catch {
    return response?.data;
  }
};
